import { Select } from '@ksyos/design-system';
import { countries } from '../../../common/utils/countries';
import { translateKey } from '../../translate';

interface ISelectCountryProps {
    error?: string;
    onChange: (value?: string) => Promise<void>;
    onDoValidate?: () => Promise<void>;
    value?: string;
}

export function SelectCountry(props: ISelectCountryProps) {
    return (
        <Select
            error={props.error}
            onChange={(item) => props.onChange(item?.value)}
            options={getCountries()}
            placeholder={translateKey('common.country')}
            required={true}
            value={
                props.value
                    ? {
                          label: getCountryLabel(),
                          value: props.value,
                      }
                    : null
            }
        />
    );

    function getCountryLabel() {
        return countries.find((item) => item.value === props.value)?.text;
    }

    function getCountries() {
        return countries
            .map((country) => ({ label: country.text, value: country.value }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }
}
